import { FlexContainer } from 'shared/Typhography/flex-box';
import { Button } from 'shared/Components';
import { useRef } from 'react';

import { FileState } from '../types';

interface HasAudioProps {
  fileState?: FileState;
  removeFile?: () => void;
}
export const HasAudio = ({ fileState, removeFile }: HasAudioProps) => {
  const audioRef = useRef<HTMLAudioElement>(null);

  return (
    <FlexContainer position="relative" dimensions={{ width: '100%', height: '100%' }}>
      <FlexContainer
        dimensions={{ width: '100%', height: '100px' }}
        justifyContent="flex-start"
        alignItems="center"
        style={{ zIndex: 1 }}
        gap="20px"
      >
        <audio controls={true} style={{ width: '100%' }} src={fileState?.url} ref={audioRef} />

        <Button variant="danger" onClick={removeFile} style={{ padding: '16px', fontSize: '20px' }}>
          REMOVE
        </Button>
      </FlexContainer>
    </FlexContainer>
  );
};
